import styled from 'styled-components';

export const JobRightRow = styled.div`
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
`;
